import { Component, OnInit, Input } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { VariantProductItemsComponent } from '../variant-product-items/variant-product-items.component';
import { FlexModule } from '@angular/flex-layout/flex';

@Component({
    selector: 'app-variant-products-modal',
    templateUrl: './variant-products-modal.component.html',
    styleUrls: ['./variant-products-modal.component.scss'],
    standalone: true,
    imports: [FlexModule, VariantProductItemsComponent, TranslateModule]
})
export class VariantProductsModalComponent implements OnInit {
    @Input() currentProductId;
    @Input() productVariants;

    constructor(
        public bsModalRef: BsModalRef,
        public translate: TranslateService,
    ) { }

    ngOnInit(): void {
    }
}
